import hero from '../img/hero-bg.png?format=avif'
import logo from '../img/logo.png?h=44&format=avif'
import logoW from '../img/logo-w.png?h=48&format=avif'
import mask from '../img/mask.png?format=avif&w=1440'
import ap1 from '../img/ap1.png?format=avif&w=639&h=518'
import postsHeader from '../img/posts-header.png?format=avif&h=460'
import postsHeaderSmall from '../img/posts-header-small.png?format=jpg&w=128&h=128&fit=cover'
import targetGroups from '../img/target-groups.png?format=avif&w=573&h=322'
//
import digitalSolutions from '../img/services/digital_solutions.png?format=avif'
import projectManagement from '../img/services/project_management.png?format=avif'
import projects from '../img/services/projects.png?format=avif'
import training from '../img/services/training.png?format=avif'
//
import apImg1 from '../img/ap/img_1.png?format=avif&w=248&h=195'
import apImg2 from '../img/ap/img_2.png?format=avif&w=248&h=195'
import apImg3 from '../img/ap/img_3.png?format=avif&w=248&h=195'
import apImg4 from '../img/ap/img_4.png?format=avif&w=248&h=195'

import partners from '../img/partners.png?format=avif&w=640'

const bgMap = {
    '--hero-bg': hero,
    '--digitalSolutions-bg': digitalSolutions,
    '--projectManagement-bg': projectManagement,
    '--projects-bg': projects,
    '--training-bg': training,
    '--targetGroups-bg': targetGroups,
    '--mask-bg': mask,
}

Object.entries(bgMap).forEach(([prop, url]) => {
    document.documentElement.style.setProperty(prop, `url(${url})`)
});